import { render, staticRenderFns } from "./atcd-historique-adulte-personnel.html?vue&type=template&id=2cd24c96&scoped=true&external"
import script from "./atcd-historique-adulte-personnel.js?vue&type=script&lang=js&external"
export * from "./atcd-historique-adulte-personnel.js?vue&type=script&lang=js&external"
import style0 from "./atcd-historique-adulte-personnel.scss?vue&type=style&index=0&id=2cd24c96&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd24c96",
  null
  
)

export default component.exports